exports.getGatewayGraphQLEndpoint = state => `${state.config.gatewayGraphUrl}`;

exports.getEmbeddedLinkEndpoint = (state, params) => `${state.config.apiUrl}/v1/entity/${params.entityId}/embedded-links/${params.slug}`;



// WEBPACK FOOTER //
// ./src/services/embeddedLinks/selectors.js